import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useMediaQuery } from 'react-responsive';
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import Swal from "sweetalert2";
import swal from "sweetalert";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPlus,
  faArrowRightLong,
  faListUl,
  faTrash,
  faPenToSquare,
  faMagnifyingGlass
} from '@fortawesome/free-solid-svg-icons';
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { PulseLoader } from "react-spinners";

const API_LIMIT = 1000;

export default function Elements() {
  document.title = "Elements";

  // const ascending = 0;
  // const descending = useState(1);
  const token = localStorage.getItem("token");
  const storageBranch = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");

  const [searchKeyword, setSearchKeyword] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);

  const [id, setId] = useState();
  const [dataUpdate, setDataUpdate] = useState();

  const [rows, setRows] = useState([]);

  const [hasSearched, setHasSearched] = useState(false);
  const [isFilterDirty, setIsFilterDirty] = useState(false);

  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);

  const [formFilter, setFormFilter] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
  });

  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storageLevel = localStorage.getItem('level');
    const storageItems = JSON.parse(localStorage.getItem('role_permission')) || [];

    if (storageLevel === "developer" || storageLevel === "superadmin") {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1
      });
    } else {
      const foundPermission = storageItems.find(
        (item) => item.menu?.url === location.pathname
      );

      if (!foundPermission) { 
        navigate('/dashboard');
      } else {
        setPermission({
          create: foundPermission.create,
          read: foundPermission.read,
          update: foundPermission.update,
          delete: foundPermission.delete
        });
      }}
  }, [location.pathname, navigate]);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),[token]
  );
  
  const yearOptions = useMemo(
    () => [
      ...new Set(getDataSemesterMap.map((item) => item?.name_year).filter(Boolean)),
    ],
    [getDataSemesterMap],
  );
  const semesterOptions = useMemo(
    () =>
      getDataSemesterMap
        .filter((item) => item?.name_year === namaTA)
        .sort((a, b) => Number(a?.semester) - Number(b?.semester)),
    [namaTA, getDataSemesterMap],
  );

  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
     isMounted.current = true;
     return () => {
       isMounted.current = false;
       abortControllers.current.forEach((c) => c.abort());
     };
  }, []);

  const schoolRequestRef = useRef(0);

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // =========================
  //  Semester + Branch
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [semesterRes, branchRes] = await Promise.all([
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranch}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;
      if (!(branchRes?.data?.data || []).length) setLoading(false);

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => Number(s.status) === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setFormFilter((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setFormFilter((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      setLoading(false);
    } catch (err) {
      if (controller.signal.aborted || !isMounted.current) return;
      setLoading(false);
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } 
  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranch, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      const requestId = ++schoolRequestRef.current;
      initSchoolDone.current = false;
      setLoadingSchool(true); // ⬅️ school mulai load
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (!isMounted.current || requestId !== schoolRequestRef.current) return;
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // ✅ FILTER ULANG UNTUK ROLE DEVELOPER
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            setFormFilter((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
            }));
          } else {
            setFormFilter((prev) => ({ ...prev, ysb_school_id: ""}));
          }
        }
      } catch (err) {
        if (isMounted.current && requestId === schoolRequestRef.current) {
          setGetDataSchool([]);
          setFormFilter((prev) => ({ ...prev, ysb_school_id: "" }));
        }
      } finally {
          if (isMounted.current && requestId === schoolRequestRef.current) {
          initSchoolDone.current = true;
          setLoadingSchool(false); // ⬅️ school SELESAI
          setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
          }
      }
    },[ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (formFilter.ysb_branch_id) fetchSchoolsByBranch(formFilter.ysb_branch_id);
  }, [formFilter.ysb_branch_id, fetchSchoolsByBranch]);

  const semesterCache = useRef({});
  const tableRequestRef = useRef(0);

  const isFilterComplete =
    !!namaTA && !!formFilter.ysb_semester_id &&
    !!formFilter.ysb_branch_id && !!formFilter.ysb_school_id && !loadingSchool;

  const GetResponseData = useCallback(async () => {
    if (!namaTA || !formFilter.ysb_semester_id ||
        !formFilter.ysb_branch_id || !formFilter.ysb_school_id || loadingSchool) return;

    const requestId = ++tableRequestRef.current;

    setIsFetching(true);
    setSearchKeyword("");

    try {
      const entries = await Promise.all(semesterOptions.map(async (semester) => {
        const response = await APILA.post("/api/elements/v2", {
          page: 1,
          limit: API_LIMIT,
          ascending: true,
          search: "",
          ysb_academic_year_id: semester.ysb_academic_year_id,
          ysb_semester_id: semester.id,
          ysb_branch_id: formFilter.ysb_branch_id,
          ysb_school_id: formFilter.ysb_school_id,
        }, fetchParams);
        return [String(semester.id), Array.isArray(response?.data?.data) ? response.data.data : []];
      }));

      if (!isMounted.current || requestId !== tableRequestRef.current) return;

      semesterCache.current = Object.fromEntries(entries);

      setRows(semesterCache.current[String(formFilter.ysb_semester_id)] || []);

      setHasSearched(true);
      setIsFilterDirty(false);

    } catch (error) {
      if (!isMounted.current || requestId !== tableRequestRef.current) return;
      setRows([]);
      setHasSearched(false);
      setIsFilterDirty(true);
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memuat data",
      });
    } finally {
      if (isMounted.current && requestId === tableRequestRef.current) 
      setIsFetching(false);
    }
  }, [namaTA, formFilter, semesterOptions, fetchParams, loadingSchool]);

  useEffect(() => {
    if (firstLoadDone.current || isFilterDirty || loading ||
        !isFilterComplete) return;
    firstLoadDone.current = true;
    GetResponseData();
  }, [loading, isFilterComplete, isFilterDirty, GetResponseData]);

  const invalidateFilter = () => {
    ++tableRequestRef.current;
    semesterCache.current = {};
    setRows([]);
    setSearchKeyword("");
    setIsFetching(false);
    setIsFilterDirty(true);
    setHasSearched(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "ysb_branch_id") {
      ++schoolRequestRef.current;
      initSchoolDone.current = false;
      setGetDataSchool([]);
      setLoadingSchool(!!value);
    }
    setFormFilter((prev) => ({
      ...prev, [name]: value,
      ...(name === "ysb_branch_id" ? { ysb_school_id: "" } : {}),
    }));
    invalidateFilter();
  };

  const changeYear = (event) => {
    const year = event.target.value;
    const options = getDataSemesterMap
      .filter((item) => item?.name_year === year)
      .sort((a, b) => Number(a?.semester) - Number(b?.semester));
    const selected = options.find((item) => Number(item?.status) === 1) || options[0];
    setNamaTA(year);
    setNamaSmstr(selected?.semester || "");
    setFormFilter((prev) => ({ ...prev, ysb_semester_id: selected?.id || "" }));
    invalidateFilter();
  };

  const handleCari = async () => {
    if (loadingSchool) {
      swal({ title: "Mohon tunggu", text: "Data sekolah sedang dimuat.", icon: "info" });
      return;
    }
    if (!isFilterComplete) {
      swal({ title: "Filter belum lengkap", text: "Pastikan Tahun Ajaran, Semester, Cabang, dan Sekolah sudah dipilih.", icon: "warning" });
      return;
    }
    await GetResponseData();
  };

  const switchSemester = (semester) => {
    if (!semester?.id || String(semester.id) === String(formFilter.ysb_semester_id)) return;
    setNamaSmstr(semester.semester || "");
    setFormFilter((prev) => ({ ...prev, ysb_semester_id: semester.id }));
    setSearchKeyword("");
    setRows(semesterCache.current[String(semester.id)] || []);
  };

  const complete =
    !!formFilter.ysb_semester_id &&
    !!formFilter.ysb_branch_id &&
    !!formFilter.ysb_school_id &&
    !loadingSchool;

  const context = {
    academicYear: namaTA,
    semesterList: semesterOptions,
  };

  const deleteById = async (id, name) => {
    Swal.fire({
      title: "Hapus data ini?",
      html: `<p class="sims-delete-description">Data <strong></strong> yang dihapus tidak dapat dikembalikan.</p>`,
      icon: "warning",
      customClass: {
        popup: "sims-delete-popup",
        icon: "sims-delete-icon",
        title: "sims-delete-title",
        actions: "sims-delete-actions",
        confirmButton: "sims-delete-confirm",
        cancelButton: "sims-delete-cancel",
        validationMessage: "sims-delete-validation",
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: "Hapus data",
      cancelButtonText: "Batal",
      reverseButtons: true,
      focusCancel: true,

      didOpen: (popup) => {
        popup.querySelector(".sims-delete-description strong").textContent = name || "Element";
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APILA.delete(
            `/api/elements/${id}`,
            fetchParams
          );
  
          if (response.data.error) {
            throw new Error(response.data.message);
          }
  
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });
        GetResponseData();
      }
    });
  };

  const viewModalUpdate = (id, element) => {
    setModalUpdate(true)
    setId(id)
    setDataUpdate(element)
  }



  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  const filteredData = useMemo(() => {
    const keyword = (searchKeyword || "").trim().toLowerCase();

    const result = !keyword
      ? rows || []
      : (rows || []).filter((item) => {
          const nameElement = (item?.name_element || "")
            .toString()
            .toLowerCase();
          
          return (
            nameElement.includes(keyword) 
          );
        });

    return [...result].sort((a, b) =>
      nameCollator.compare(
        (a?.name_element || "").toString().trim(),
        (b?.name_element || "").toString().trim()
      )
    );
  }, [rows, searchKeyword, nameCollator]);

  const displayData = filteredData;

  const dimensionRowSpans = useMemo(() => {
    const spans = Array(displayData.length).fill(0);
    let index = 0;

    const normalizeDimension = (value) =>
      (value || "-").toString().trim().toLowerCase();

    while (index < displayData.length) {
      const currentDimension = normalizeDimension(
        displayData[index]?.name_dimensi
      );

      let count = 1;

      while (
        index + count < displayData.length &&
        normalizeDimension(displayData[index + count]?.name_dimensi) ===
          currentDimension
      ) {
        count += 1;
      }

      spans[index] = count;
      index += count;
    }

    return spans;
  }, [displayData]);

  const navigateIndikator = (id, slug_name) => {
    navigate("/elements/sub-elements/" + id  + "/" + slug_name)
  }

  return (
    <div className="body sims-page">
      
      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
          semesterOptions={semesterOptions}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          semesterOptions={semesterOptions}
          id={id}
          dataUpdate={dataUpdate}
          selectedSemesterId={formFilter.ysb_semester_id}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faListUl} />
            </span>

            <h4 className="page-title-text">Element</h4>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              onClick={() => setModalAdd(true)}
              className="btn btn-create sims-header-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>{isTabletOrMobile ? "Element" : "Tambah Element"}</span>
            </button>
          </div>
        </div>

        <nav
          aria-label="breadcrumb"
          className="sims-breadcrumb-nav mt-4"
        >
          <ol className="sims-breadcrumb">
            <li className="sims-breadcrumb-item">
              <Link to="/dashboards-main">Dashboard</Link>
            </li>

            <li className="sims-breadcrumb-separator">/</li>

            <li
              className="sims-breadcrumb-item active"
              aria-current="page"
            >
              Element
            </li>
          </ol>
        </nav>
      </div>
      
      <div className="body-content sims-content">
        {loading ? (
          <div className="sims-filter-card  sims-filter-card-two-shimmer">
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className="shimmer sims-filter-skeleton" />
            ))}
          </div>
        ) : (
          <div className="sims-filter-card sims-filter-card-two">
            <div className="sims-filter-field">
              <label className="sims-filter-label">Tahun Ajaran</label>
              <select
                className="sims-filter-select"
                value={namaTA}
                onChange={changeYear}
              >
                <option value="" disabled>
                  Pilih Tahun Ajaran
                </option>
                {yearOptions.map((year) => (
                  <option key={year} value={year}>
                    {year}{getDataSemesterMap.some((item) => item.name_year === year && Number(item.status) === 1) ? " (Aktif)" : ""}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-filter-field">
              <label className="sims-filter-label">Cabang</label>
              <select
                className="sims-filter-select"
                name="ysb_branch_id"
                value={formFilter.ysb_branch_id}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Pilih Cabang
                </option>
                {getDataBranch.map((item) => (
                  <option key={item?.branch_code} value={item?.branch_code}>
                    {item?.branch_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="sims-filter-field">
              <label className="sims-filter-label">Sekolah</label>
              <select
                className="sims-filter-select"
                name="ysb_school_id"
                value={formFilter.ysb_school_id}
                onChange={handleChange}
                disabled={loadingSchool || !formFilter.ysb_branch_id}
              >
                <option value="" disabled>
                  {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                </option>
                {getDataSchool.map((item) => (
                  <option key={item?.school_code} value={item?.school_code}>
                    {item?.school_name}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="sims-filter-action">
                <button
                  type="button"
                  className="sims-filter-button"
                  disabled={!complete || isFetching || (hasSearched && !isFilterDirty)}
                  onClick={handleCari}
                >
                  Tampilkan Data
                </button>
              </div>

          </div>
        )}

        {isFetching && (
          <div className="sims-loading">
            <PulseLoader color="#3f5bea" size={12} />
          </div>
        )}

        {!loading && !isFetching && !hasSearched && (
          <div className="sims-empty-state">
            Silakan klik <strong>Tampilkan Data</strong> untuk menampilkan data sesuai filter.
          </div>
        )}

        {hasSearched && !isFetching && (
          <>
            <div className="sims-search-wrap mb-3">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="sims-search-icon"
              />
              <input
                type="text"
                className="sims-search-input"
                placeholder="Cari element..."
                value={searchKeyword}
                onChange={(event) => setSearchKeyword(event.target.value)}
              />
            </div>

            <div className="sims-table-tab-card ">
              <div className="sims-table-tab-head">
                <div className="sims-table-tab-title">
                  <h5>Data Element - Semester {namaSmstr}</h5>
                </div>
                <div className="sims-table-tab-semester-switch">
                  {semesterOptions.map((semester) => (
                    <button
                      type="button"
                      key={semester?.id}
                      className={`sims-table-tab-semester ${String(formFilter.ysb_semester_id) === String(semester?.id) ? "is-active" : ""}`}
                      onClick={() => switchSemester(semester)}
                      disabled={isFetching}
                    >
                      Semester {semester?.semester}
                    </button>
                  ))}
                </div>
              </div>
              
              <div className="sims-table-tab-wrap">
              <table className="sims-table">
                  <thead>
                    <tr>
                      {/* <th className="sims-col-number">No</th> */}
                      <th>Dimensi</th>
                      <th>Element</th>
                      <th>Nama Element</th>
                      <th className="text-center">Indikator</th>
                      <th className="sims-col-action">Aksi</th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayData.length > 0 ? (
                      displayData.map((row, index) => (
                        <tr key={row?.id || index}>
                          {/* <td className="sims-col-number">
                            <span className="sims-number-badge">
                              {index + 1}
                            </span>
                          </td> */}

                          {dimensionRowSpans[index] > 0 && (
                            <td
                              rowSpan={dimensionRowSpans[index]}
                              style={{
                                verticalAlign: "middle",
                                borderLeft: "1px solid #d9e2f2",
                                borderRight: "1px solid #d9e2f2",
                                borderTop: "1px solid #d9e2f2",
                                borderBottom: "1px solid #d9e2f2",
                              }}
                            >
                              <span className="sims-text-bold">
                                {row.name_dimensi || "-"}
                              </span>
                            </td>
                          )}

                          <td>
                            <span className="sims-name-text">
                              {row.name_element || "-"}
                            </span>
                          </td>

                          <td>
                            <span className="sims-name-text">
                              {row.description || "-"}
                            </span>
                          </td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="sims-table-button"
                              onClick={() => navigateIndikator(row?.id, row?.slug_name)}
                              title="Atur indikator"
                            >
                              <FontAwesomeIcon icon={faArrowRightLong} />
                              Detail
                            </button>
                          </td>

                          <td className="sims-col-action">
                            <div className="sims-action-wrap">
                              <button
                                type="button"
                                className="sims-action-button sims-action-edit"
                                title="Update Data"
                                onClick={() => viewModalUpdate(row?.id, row)}
                              >
                                <FontAwesomeIcon icon={faPenToSquare} />
                              </button>

                              <button
                                type="button"
                                className="sims-action-button sims-action-delete"
                                title="Hapus cabang"
                                onClick={() => {deleteById(row?.id, row?.name_element)}}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="sims-empty-state">
                           <div className="module-empty-state-content">
                             Data element tidak ditemukan
                           </div>
                         
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
